import qs from "qs";
import { request, asyncConfig, baseURL } from "./axios";

export const CommmonGet = <T>(url: string, params?: any, timeout?: number) =>
  request.get<T>(url, params, {
    timeout: timeout || 15000,
    paramsSerializer: (params) => {
      return qs.stringify(params, { indices: false });
    },
  });

export const CommmonPost = <T>(url: string, params?: any, timeout: number = 15000) =>
  request.post<T>(url, params, {
    timeout,
    data: params,
  });
export const CommmonPostNoBody = <T>(url: string, params?: any, timeout: number = 15000) =>
  request.post<T>(url, params, {
    timeout,
    data: params,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
//   文件流下载
export const CommonDown = <T>(url: string, params?: any) =>
  request.getDown<T>(url, params, {
    timeout: 15000,
    paramsSerializer: (params) => {
      return qs.stringify(params, { indices: false });
    },
    responseType: "blob",
  });

export const getBaseAddr = <T>(params?: any) =>
  request.get<T>(
    "/mainServerAddr/getMainServerAddr",
    params,
    { timeout: 15000 },
    asyncConfig
  );
export const onlineReq = <T>(params?: any) =>
  request.get<T>(
    "/mainServerAddr/WS_UserMgr_G_IsOnline",
    params,
    {
      timeout: 15000,
      headers: { ...params },
    },
    asyncConfig
  );
//   获取是否购买信息补录
export const getIsBuyRecord = <T>(params?: any) =>
  request.get<T>(
    "/system/informationSupplementModuleStatus",
    params,
    { timeout: 15000 },
    asyncConfig
  );
// 获取学校版本
export const getSchoolVersion = <T>(params?: any) =>
  request.get<T>(
    "/SystemSettingManagement/getSchoolVersion",
    params,
    { timeout: 15000 },
    asyncConfig
  );
// 获取学校类型
export const getSchoolLevel = <T>(params?: any) =>
  request.get<T>(
    "/SystemSettingManagement/showReport",
    params,
    { timeout: 15000 },
    asyncConfig
  );
// 获取学校类型 1=大学，2=中小学，3=高职，4=中职
export const getSchoolLevel1 = <T>(params?: any) =>
  request.get<T>(
    "/system/schoolVersion",
    params,
    { timeout: 15000 },
    asyncConfig
  );

export const getUserInfo = <T>(params?: any) =>
  request.get<T>(
    "/mainServerAddr/WS_UserMgr_G_GetAdmin",
    params,
    { timeout: 15000 },
    asyncConfig
  );


export const CommmonDel = <T>(url: string, params?: any) => {
  return request.delete<T>(url, params, {
    timeout: 15000,
    data: params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { indices: false });
    },
  });
};

export const CommmonPut = <T>(url: string, params?: any) =>
  request.put<T>(url, params, { timeout: 15000 });

export const CommmonPatch = <T>(url: string, params?: any) => {
  //   request.patch<T>(url, params, { timeout: 15000 })
  return request.patch<T>(url, params, {
    timeout: 15000,
    data: params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { indices: false });
    },
  });
};

//  公共业务方法
// 获取下拉招生计划
export const reqPlanList = (params?: any) => {
  return CommmonGet("/common/select/plan", params);
};

export const CommonUpFile = <T>(url: string, params?: any) => {
  return request.post<T>(url, params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const DownLoadFile = (fileName: string, path: string) => {

  // let data = {
  //   fileName: fileName,
  //   path: path,
  // };
  //   return CommmonGet("/common/download", data);
  let url =
    baseURL +
    "/common/download?fileName=" +
    encodeURIComponent(fileName) +
    "&path=" +
    encodeURIComponent(path);
  window.open(url, "_parent");
};
